var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4375108_logo_telegram_icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x33_35-telegram"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M32.1863 6.52428L27.5766 28.2637C27.2289 29.798 26.3219 30.1798 25.033 29.4571L18.0093 24.2813L14.6204 27.5409C14.2454 27.9159 13.9317 28.2297 13.2088 28.2297L13.7134 21.0763L26.7311 9.31328C27.2971 8.80872 26.6084 8.52909 25.8514 9.03371L9.75836 19.1669L2.83013 16.9985C1.32311 16.5279 1.29588 15.4914 3.14377 14.7686L30.2429 4.32856C31.4975 3.85807 32.5955 4.60806 32.1863 6.52428Z",
    fill: "#8cbe26"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterTelegram);
export default __webpack_public_path__ + "static/media/footer-telegram.fbb305f7a6cb855a31423289219b6445.svg";
export { ForwardRef as ReactComponent };